const currentDate = new Date()
const external_documents = {
  permissionSource: 'api::external-document.external-document',
  creationTitle: 'Create External Document',
  creationEndPoint: '/external-documents',
  detailTitle: 'External Document: :title',
  detailEndPoint: '/external-documents/:id?populate=*',
  detail: [
    {
      isLayout: true,
      layoutPattern: '1-1',
      children: [
        {
          label: 'Code',
          value: 'code',
          tag: 'input',
          type: 'text',
          placeholder: 'External Document Code',
          required: true,
        },
        {
          label: 'Name',
          value: 'name',
          tag: 'input',
          type: 'text',
          placeholder: 'External Document Name',
          required: true,
        },
      ],
    },
    {
      label: 'Description',
      value: 'description',
      tag: 'richTextarea',
      placeholder: 'External Document Description',
    },
    {
      isLayout: true,
      layoutPattern: '1-1',
      children: [
        {
          label: 'Business Entity',
          value: 'business_entity',
          tag: 'single-select',
          dataSourceUrl: '/business-entities',
          dataLabel: 'title',
          required: true,
        },
        {
          label: 'Issue Date',
          value: 'issue_date',
          tag: 'date-picker',
        },
      ],
    },
    {
      isLayout: true,
      layoutPattern: '1-1',
      children: [
        {
          isLayout: true,
          layoutPattern: '1',
          children: [
            {
              label: 'Document Type',
              value: 'document_type',
              tag: 'single-select',
              dataSourceUrl: '/document-types',
              dataLabel: 'title',
              required: true,
            },
            {
              label: 'Payment',
              value: 'payment',
              tag: 'input',
              type: 'text',
            },
          ],
        },
        {
          label: 'Document Items',
          value: 'document_items',
          tag: 'multi-media',
          acceptFile: '*',
          required: true,
        },
      ],
    },
    {
      isLayout: true,
      layoutPattern: '1-1',
      children: [
        {
          label: 'Staff (Our side)',
          value: 'staff',
          tag: 'single-select',
          dataSourceUrl: '/staffs',
          dataLabel: 'name',
          required: true,
        },
        {
          label: "Contact Person \n(Client's / Partner's / Supplier's side)",
          value: 'contact_person',
          tag: 'single-select',
          dataSourceUrl: '/contact-people',
          dataLabel: 'name',
        },
      ],
    },
    {
      isLayout: true,
      layoutPattern: '1-1-1',
      children: [
        {
          label: 'Client',
          value: 'client',
          tag: 'single-select',
          dataSourceUrl: '/clients',
          dataLabel: 'name',
        },
        {
          label: 'Partner',
          value: 'partner',
          tag: 'single-select',
          dataSourceUrl: '/partners',
          dataLabel: 'name',
        },
        {
          label: 'Supplier',
          value: 'supplier',
          tag: 'single-select',
          dataSourceUrl: '/suppliers',
          dataLabel: 'name',
        },
      ],
    },
    {
      isLayout: true,
      layoutPattern: '1-1-1',
      children: [
        {
          label: 'Create Date / Time',
          value: 'custom_created_at',
          tag: 'static-text',
        },
        {
          label: 'Update Date / Time',
          value: 'custom_updated_at',
          tag: 'static-text',
        },
      ],
    },
  ],
  creationData: {
    business_entity: ':active_business_entity',
    issue_date: currentDate,
  },
}
export default external_documents
